module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/4RDJbu/tc-custom/9781939931894.jpg?1716663321175",
      "alt": "This image is the cover for the book Very German Christmas, Very Christmas"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Very German Christmas, Very Christmas\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This collection of new and classic Christmas literature includes stories by Herman Hesse, Joseph Roth, The Brothers Grimm, and many others.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" This collection brings together traditional and contemporary holiday stories from Austria, Switzerland, and Germany. You'll find classic works by Johann Wolfgang von Goethe, Heinrich Heine, Rainer Maria Rilke, Thomas Mann and Arthur Schnitzler, as well as more recent tales by writers like Heinrich Böll, Peter Stamm and Martin Suter. It also includes the first published English translation of Joseph Roth’s story “Christmas in Cochinchina.”"), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Enjoy "), _c('i', [_vm._v("Eine fröhliche Weihnachten")]), _vm._v("―A Merry Christmas―made all the more festive with these literary treats redolent of candle-lit trees, St. Nikolaus, gingerbread, Gugelhopf and stollen cakes, all accompanied by plenty of schnapps.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Wolfgang von Goethe, Hermann Hesse, Heinrich Heine, , Kurt Tucholsky, Erich Kästner, Ilse Frapan, Martin Suter, Peter Stamm, Rainer Maria Rilke, Arthur Schnitzler, Thomas Mann, Heinrich Böll, Helene Stökl, E. T. A. Hoffmann, Joseph Roth, Peter Rosegger, Wolfdietrich Schnurre, Ernst Anschütz\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    New Vessel Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4b7db194","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0